var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile)?_c('div',[_c('Mobile')],1):_vm._e(),(!_vm.isMobile)?_c('div',[_c('Pc')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }